<template>
  <div>
    <Navbar></Navbar>
    <div class="section_1">
     <div class="content-box">
      <div class="title">More than an ECG monitor</div>
      <p class="info">Heart Smart™ , the ultimate ECG monitor combining high accuracy HRV measurement with advanced analysis. This sleek and compact device revolutionizes heart health monitoring, providing precise insights in a fingertip size, allowing you to understand your body's response to stress and assess overall well-being. With Heart Smart™ , you can upload data to our secure center and unlock advanced analysis capabilities. Expert algorithms analyze your ECG data, detecting arrhythmias and providing comprehensive stress analysis. Accessible to fitness enthusiasts, health-conscious individuals, and those managing cardiac conditions,Heart Smart™ 's user-friendly interface and intuitive operation make it a convenient and reliable choice.
      </p>
      <div class="icon-group">
        <div class="item">
          <img src="@/assets/2.0/icon-08.png" />
          <div class="text">Live data <br>collection</div>
        </div>
        <div class="item">
          <img src="@/assets/2.0/icon-09.png" />
          <div class="text">Secure data <br>storage</div>
        </div>
        <div class="item">
          <img src="@/assets/2.0/icon-10.png" />
          <div class="text">Intelligent data <br>analysis</div>
        </div>
      </div>
     </div>
    </div>
    <div class="section_4">
      <div class="title">
        <p style="position: relative;"><span>Heart Smart</span><span style="font-size: 36px;position: absolute; top:0px;margin-right: 5px;">™ </span> <span style="padding-left: 20px;">is built with lighter weight and</span></p>
          <p>better performanc</p>
      </div>
      <div class="table-list">
        <img src="@/assets/2.0/icon_group_3.png" />
      </div>
      <div class="table-img"><img src="@/assets/2.0/icon_group_2.png" /></div>
    </div>
    <div class="section_5">
      <div class="c-box">
        <div class="d-flex align-center btn-list">
          <div class="c-title" :class="{'active': active ===1 }" @click="tabClick(1)" style="width: 40%;">
            <div class="text-bg">WHAT IS ARRGYTHMIAS? </div>
            <div class="icon">
              <img class="_bottom" src="@/assets/2.0/arrow-bottom.png">
              <img class="_top" src="@/assets/2.0/arrow-top.png">
            </div>
          </div>
          <div class="c-title" :class="{'active': active ===2 }" @click="tabClick(2)" style="width: 60%;">
            <div class="text-bg">WHAT IS HEART RATE VARIABILITY (HRV) ? </div>
            <div class="icon">
              <img class="_bottom" src="@/assets/2.0/arrow-bottom.png">
              <img class="_top" src="@/assets/2.0/arrow-top.png">
            </div>
          </div>
        </div>
        <div class="text-box">
          <p v-for="item in arr">{{ item }}</p>
        </div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";


export default {
  name: "index",
  components: {
    Navbar,
    FooterDom
  },
  data() {
    return {
      arr: [
        "Arrhythmias are abnormalities in the rhythm of the heartbeat. Our hearts have their own electrical system that regulates the timing and coordination of the heartbeats. This system ensures that the heart contracts and relaxes in a regular pattern, allowing blood to be pumped effectively throughout the body. However, in the case of arrhythmias, there is a disruption in this electrical system, leading to irregular heart rhythms.",
        "Arrhythmias can manifest in different ways, ranging from occasional skipped or extra beats to more severe and persistent irregular rhythms. But people may not even notice their arrhythmias, which is why it is important to early detect the potential risk and consult a healthcare professional. ",
        "An electrocardiogram (ECG) is a commonly used test that can help detect and diagnose arrhythmias. It measures the electrical activity of the heart by detecting the electrical signals (impulses or waves) from the heart through electrodes attached on the body. Although some smart watches or fitness bands are built with ECG function, they are not replaceable of accurate ECG monitors for diagnosis purpose."
      ],
      arrText: [
        "Arrhythmias are abnormalities in the rhythm of the heartbeat. Our hearts have their own electrical system that regulates the timing and coordination of the heartbeats. This system ensures that the heart contracts and relaxes in a regular pattern, allowing blood to be pumped effectively throughout the body. However, in the case of arrhythmias, there is a disruption in this electrical system, leading to irregular heart rhythms.",
        "Arrhythmias can manifest in different ways, ranging from occasional skipped or extra beats to more severe and persistent irregular rhythms. But people may not even notice their arrhythmias, which is why it is important to early detect the potential risk and consult a healthcare professional. ",
        "An electrocardiogram (ECG) is a commonly used test that can help detect and diagnose arrhythmias. It measures the electrical activity of the heart by detecting the electrical signals (impulses or waves) from the heart through electrodes attached on the body. Although some smart watches or fitness bands are built with ECG function, they are not replaceable of accurate ECG monitors for diagnosis purpose."
      ],
      hrvText: [
        "Heart rate variability (HRV) refers to the variation in time intervals between successive heartbeats. In simpler terms, it measures the changes in the timing between each heartbeat.",
        "HRV is influenced by the balance between the sympathetic and parasympathetic branches of the autonomic nervous system.",
        "Studies have shown that increased stress levels are associated with decreased HRV. When we experience stress, the sympathetic nervous system becomes more dominant, leading to a decrease in HRV. Conversely, when we are in a relaxed state, the parasympathetic nervous system becomes more active, resulting in increased HRV. A higher HRV indicates that the body is better able to adapt and respond to changing conditions. Monitoring HRV can provide lots of insights into our body's response to stress.",
      ],
      active:1,
    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    tabClick(row){
      this.active = row;
      this.arr = row === 1 ? this.arrText : this.hrvText;
    }
  }
};
</script>

<style lang="less" scoped>
.content-box{
  max-width: 1920px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.section_1{
  width: 100%;
  height: 705px;
  background: url("../../assets/2.0/h_section_1_bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  img{
    width: 100%;
  }
  .title{
    font-size: 60px;
    color: #000;
    padding-top: 54px;
    margin-left: 276px;
  }
  .info{
    margin-left: 276px;
    width: 634px;
    font-size: 20px;
    color: #000;
    margin-top: 40px;

  }
  .icon-group{
    display: flex;
    align-items: center;
    margin-top: 80px;
    margin-left: 276px;
    .item{
      text-align: center;
      margin-right: 50px;
      img{
        width: 52px;
        height: 52px;
      }
      .text{
        font-size: 18px;
        color: #000;
        margin-top: 20px;
      }
    }
  }
}

.section_4{
  width: 100%;
  // height: 909px;

  .title{
    p{
      text-align: center;
    }
    margin-top: 67px;
    font-size: 60px;
    width: 100%;

  }
  .info{
    margin-top: 20px;
    font-size: 20px;
    width: 100%;
    text-align: center;
  }
  .table-list{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    img{
      margin-top: 60px;
      margin-left: 160px;
      width: 531px;
    }
  }
  .table-img{
      width: 843px;
      margin: 60px auto 0 auto;
      img{
        width: 100%;
        margin-bottom: 60px;
      }
    }
}
.section_5{
  width: 100%;
  padding-bottom: 60px;
  background: #EAEAEA;
  display: flex;

  justify-content: center;
  .c-box{
    max-width: 1420px;
    padding: 80px 30px 0 30px;

    .text-box{
      min-height: 640px;
      background: #fff;
      padding: 90px;
      width: 100%;
      margin-top: 20px;
      font-size: 24px;
      line-height: 40px;
      p{
        margin-bottom: 30px;
      }
    }
  }
  .c-title{
    color: #000;
    font-size: 28px;
    margin-right: 20px;
    height: 64px;
    line-height: 64px;
    transition: all 0.2s;
    display: flex;
    cursor: pointer;
    font-family: "Light";

    &:hover{
      .text-bg{
        background: #79e7b0;
        color: #fff;

      }
      .icon{
        background: #79e7b0;
      }
    }
    .text-bg{
      background: #fff;
      padding: 0 30px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child{
      margin-right: 0;
    }
    .icon{
      margin-left: 5px;
      background: #fff;
      height: 64px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      ._top{
        width: 15px;
        height: 9px;
        display: none;
      }
      ._bottom{
        width: 14px;
        height: 9px;
        display: block;
      }
    }
    &.active{
      color: #fff;
      .text-bg{
      background: #50C88C;
    }
      .icon{
        background: #50C88C;
        ._top{
        display: block;
      }
      ._bottom{
        display: none;
      }
      }
    }
  }
}

/* 桌面显示器，小于 1800px） */
@media (max-width: 1800px) {
  .section_1{
  .title{
    font-size: 48px;
  }
  .info{
    width: 500px;
    font-size: 16px;
  }
}
}

/* 桌面显示器，小于 1550px） */
@media (max-width: 1550px) {
  .section_1{
  .title{
    font-size: 30px;
  }
  .info{
    width: 300px;
    font-size: 16px;
  }
  .icon-group{
    .item{
      margin-right: 20px;
      img{
        width: 30px;
        height: 30px;
      }
      .text{
        font-size: 12px;
        color: #000;
        margin-top: 20px;
      }
    }
  }
}
}

/* 桌面显示器，小于 1200px） */
@media (max-width: 1200px) {
  .section_1{
  .title{
    margin-left: 66px;
  }
  .info{
    margin-left: 66px;
  }
  .icon-group{
    margin-left: 66px;
  }
}
  .btn-list{
    flex-direction: column;
    .c-title{
      width: 100% !important;
      margin-bottom: 30px;
      margin-right: 0;
    }
  }
  .section_5{
    .c-box{
      padding: 80px 66px 0 66px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/howHeart.vue